import React from "react"
import "../styles/Modal.css"

function Modal({ open, responsive, onClickBackdrop, className, children }) {
  const containerClasses = `modal ${open ? "modal-open" : ""} ${
    responsive ? "modal-bottom modal-middle" : ""
  } `
  return (
    <>
      <div
        aria-label="Modal"
        aria-hidden={!open}
        aria-modal={open}
        className={containerClasses}
        onClick={(e) => {
          e.stopPropagation()
          if (e.target === e.currentTarget) {
            e.stopPropagation()
            if (onClickBackdrop) {
              onClickBackdrop()
            }
          }
        }}
      >
        <div className={`modal-box ${className}`}>
          <button
            className="modal-close-button"
            autoFocus
            onClick={onClickBackdrop}
          >
            X
          </button>
          {children}
        </div>
      </div>
    </>
  )
}

function ModalHeader({ children, className }) {
  return <div className={`modal-header ${className}`}>{children}</div>
}

function ModalActions({ children, className }) {
  return <div className={`modal-actions ${className}`}>{children}</div>
}

export { Modal, ModalHeader, ModalActions }
